import { Text, View } from '@react-pdf/renderer';

import { CommentarySection } from '../components/CommentarySection.tsx';
import { List } from '../components/List.tsx';
import { Tkv2PDFPage } from '../components/Tkv2PDFPage.tsx';
import { fontStyles, gridStyles, reconciliationPageStyles } from '../styles.ts';
import type { ReconciliationPageProps } from '../types.ts';

export const ReconciliationPage = ({
  subjectAddress,
  reconciliationCommentary,
  highestAndBestUseCommentary,
  feasibilityCommentary,
  alternativeComparablesCommentary,
  totalCostToCureCommentary,
  revisionCommentary,
  isRevision,
  revisionType,
  commentaryV2,
  alerts,
  revisionData,
  includeTotalCostToCure,
}: ReconciliationPageProps) => {
  const shouldDisplayAlertCommentarySection = alerts
    .filter(({ status }) => status === 'dismissed')
    .some(({ type }) => commentaryV2.alerts?.[type]);


  return (
    <Tkv2PDFPage title="Reconciliation" address={subjectAddress}>
      {includeTotalCostToCure && (
        <CommentarySection
          title="Total Cost to Cure Commentary"
          commentary={totalCostToCureCommentary}
        />
      )}
      {isRevision && (
        <>
          <View style={reconciliationPageStyles.section}>
            <Text style={fontStyles.h5}>{revisionType} Commentary</Text>
            <Text style={fontStyles.body}>{revisionCommentary?.replace('\n', '\n\n')}</Text>
          </View>
          {alternativeComparablesCommentary?.map((commentary, index) => {
            const comparableKey =
              revisionData?.comparables?.[index]?.address ?? `alternative-comparable-${index}`;
            return (
              <View key={comparableKey} style={reconciliationPageStyles.section}>
                <Text style={fontStyles.bodyBold}>
                  Alternative Comparable {index + 1}:{' '}
                  {revisionData?.comparables?.[index]?.address || 'N/A'}
                </Text>
                <Text style={fontStyles.body}>{commentary?.replace('\n', '\n\n')}</Text>
              </View>
            );
          })}
        </>
      )}



      {feasibilityCommentary && (
        <View style={reconciliationPageStyles.section}>
          <Text style={fontStyles.h5}>Feasibility Commentary</Text>
          <Text style={fontStyles.body}>{feasibilityCommentary?.replace('\n', '\n\n')}</Text>
        </View>
      )}
      <View style={reconciliationPageStyles.section}>
        <Text style={fontStyles.h5}>Reconciliation Commentary</Text>
        <Text style={fontStyles.body}>{reconciliationCommentary?.replace('\n', '\n\n')}</Text>
      </View>
      <View style={reconciliationPageStyles.section}>
        <Text style={fontStyles.h5}>Highest & Best Use Commentary</Text>
        <Text style={fontStyles.body}>{highestAndBestUseCommentary?.replace('\n', '\n\n')}</Text>
      </View>
      {shouldDisplayAlertCommentarySection && (
        <View style={{ ...gridStyles.gridSection, marginRight: 20 }}>
          <Text style={fontStyles.h5}>Notes</Text>
          <List
            type="number"
            items={alerts
              .filter(({ status }) => status === 'dismissed')
              .map(({ type, message }) => (
                <Text key={type} style={fontStyles.body}>
                  <Text style={fontStyles.bodyBold}>{message}&nbsp;</Text>
                  {commentaryV2.alerts?.[type]}
                </Text>
              ))}
          />
        </View>
      )}
    </Tkv2PDFPage>
  );
};
